import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Utils } from '../helpers/Utils';
import { CoreModule } from '../core.module';

@Injectable({ providedIn: CoreModule })
export class PrivateCloudGuard  {
    constructor(private router: Router) {}

    canActivate(): boolean {
        if (Utils.isPrivateCloud) {
            // Redirect to root when private cloud blocks access
            this.router.navigate(['/']);
            return false;
        }
        return true;
    }
}
